import React from 'react'
import { useTranslation, Trans } from 'react-i18next'

import EMAILS from 'common/constants/emails'

import Block from '../../components/Block/Block'

import image1 from './i/image1.png'
import image2 from './i/image2.png'
import image3 from './i/image3.png'

const Basics = () => {
    const { t } = useTranslation()

    return (
        <>
            <Block
                image={image1}
                title={t('What is Interacty project?')}
                article={
                    <Trans
                        i18nKey="Each project can consist of one or more different blocks: texts, images, quizzes, games etc. For example <lnk>this one</lnk> contains: 1 quiz, 1 interactive image, 1 video and some text blocks."
                        components={{
                            lnk: <a href={`${process.env.REACT_APP_SSR_URL}/templates/23568495`} target="_blank" />,
                        }}
                    />
                }
            />
            <Block
                image={image2}
                title={t('What templates are and how can I use them?')}
                article={
                    <Trans
                        i18nKey="Templates are ready made projects. You can use them <bold>for FREE</bold> with no changes! Or clone and change the content you need – click “Edit” next to the template. Yes, it’s your first project and you may share it with students!"
                        components={{
                            bold: <strong />,
                        }}
                    />
                }
            />
            <Block
                image={image3}
                title={t('How to get help?')}
                article={
                    <Trans
                        i18nKey="We have a <lnk>help center</lnk> and <emailLink>{{email}}</emailLink>"
                        components={{
                            lnk: <a href="https://help.interacty.me/" target="_blank" />,
                            emailLink: <a href={`mailto:${EMAILS.INTERACTY_SUPPORT}`} />,
                        }}
                        values={{
                            email: EMAILS.INTERACTY_SUPPORT,
                        }}
                    />
                }
            />
        </>
    )
}

export default Basics
